import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { DataService } from '../services/data/data.service';

@Injectable({
  providedIn: 'root'
})
export class UserWelcomeGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private dataService: DataService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    this.authService.isAuth() ?
      this.dataService.titleWelcome$.next(`Bienvenue ${this.authService.getDecodedToken().middle_name}`) :
      this.dataService.titleWelcome$.next('Nautisme et plaisance en Hauts-de-France');

    return true;
  }

}
